'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AutomationName = require('../../../services/AutomationName');

var _AutomationName2 = _interopRequireDefault(_AutomationName);

var _reactIntl = require('react-intl');

var _cwUi = require('cw-ui');

var _ClickTracker = require('../../../services/ClickTracker');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CurrencyField = function (_React$Component) {
  (0, _inherits3.default)(CurrencyField, _React$Component);

  function CurrencyField(props) {
    (0, _classCallCheck3.default)(this, CurrencyField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CurrencyField.__proto__ || (0, _getPrototypeOf2.default)(CurrencyField)).call(this, props));

    _this.getThousandSeparator = function () {
      var formatNumber = _this.props.intl.formatNumber;

      var valueString = formatNumber(1000.00);
      return valueString.charAt(valueString.indexOf("1") + 1);
    };

    _this.getDecimalSeparator = function () {
      var formatNumber = _this.props.intl.formatNumber;

      var valueString = formatNumber(1000.99);

      var lengthCounter = valueString.length - 1;

      while (valueString.charAt(lengthCounter) === '9') {
        lengthCounter--;
      }

      return valueString.charAt(lengthCounter);
    };

    _this.getCurrencySymbol = function () {
      var formatNumber = _this.props.intl.formatNumber;

      var valueString = formatNumber(1000.00, { style: 'currency', currency: _this.props.currency });
      var thousandSeparator = _this.getThousandSeparator();
      var decimalSeparator = _this.getDecimalSeparator();
      var regexString = '([0-9-' + thousandSeparator + decimalSeparator + '])';
      var regex = new RegExp(regexString, "gm");
      var symbol = valueString.replace(regex, '');
      return symbol;
    };

    _this.getMaxDecimalUnits = function () {
      var formatNumber = _this.props.intl.formatNumber;

      var valueString = formatNumber(1000.999999999999, {
        style: 'currency', currencyDisplay: 'code',
        currency: _this.props.currency
      });
      var decimal = _this.getDecimalSeparator();
      valueString = valueString.replace(_this.props.currency, '').trim();
      var counter = valueString.length - 1;
      var decimalUnits = 0;
      while (valueString.charAt(counter) !== decimal) {
        counter--;
        decimalUnits++;
      }
      return decimalUnits;
    };

    _this.getNegativeSymbol = function () {
      var formatNumber = _this.props.intl.formatNumber;

      var valueString = formatNumber(-1);

      var negative = valueString.charAt(0);

      if (negative === '1') {
        negative = valueString.charAt(1);
      }

      return negative;
    };

    _this.formatToCurrency = function (value) {
      var formatNumber = _this.props.intl.formatNumber;


      var newVal = value;
      if (typeof value !== "number") {
        newVal = parseFloat(value);
      }
      if (!isNaN(newVal)) {
        return formatNumber(newVal, { style: 'currency', currency: _this.props.currency });
      } else {
        return value;
      }
    };

    _this.getAutomationName = function () {
      return _AutomationName2.default.get('cur', _this.props.automationName);
    };

    _this.handleChange = function (value) {
      (0, _ClickTracker.addEditTrack)(_this.getAutomationName());
      _this.props.onChange(value);
    };

    _this.state = {
      decimal: _this.getDecimalSeparator(),
      thousands: _this.getThousandSeparator(),
      symbol: _this.getCurrencySymbol(),
      maxDecimal: _this.getMaxDecimalUnits(),
      negative: _this.getNegativeSymbol()
    };
    return _this;
  }

  /**
   * Get the thousands separator of any locale by creating a formatted number string of 1,000
   * and grabbing the first character after the 1
   */


  /**
   * Grabs the decimal separator by creating an instance of a formatted number string equal to 1000
   * and grabbing the first non zero non symbol character from the right.
   */


  /**
   * Get the currency symbol at the start or end of string by creating a regex that includes
   * the thousands and decimal separators and 0-9 values and stripping out everything that matches.
   * What remains will be the currency symbol.
   */


  /**
   * Gets the number of allowed characters following the decimal separator. Usually this will be 2 or 3.
   */


  /**
   * Retrun the negative symbol used by the locale
   */


  /**
   * Calls React-Intl's formNumber method on the provided value to format it as currency.
   * This method should be passed down as a prop to CwCurrencyField.
   */


  (0, _createClass3.default)(CurrencyField, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_cwUi.CwCurrencyField, (0, _assign2.default)({}, this.props, {
        cwId: this.getAutomationName(),
        onChange: this.props.onChange ? this.handleChange : undefined,
        value: this.props.value,
        symbol: this.state.symbol,
        decimal: this.state.decimal,
        thousands: this.state.thousands,
        negative: this.state.negative,
        currency: this.props.currency,
        maxDecimalUnits: this.state.maxDecimal,
        formatToCurrency: this.formatToCurrency
      }));
    }
  }]);
  return CurrencyField;
}(_react2.default.Component);

CurrencyField.propTypes = (0, _assign2.default)({
  /**
   * Element id used as selection and search for automation testing
   */
  automationName: _propTypes2.default.string
}, _cwUi.CwCurrencyField.propTypes, {
  /**
   * Override required prop from spread, these props should never
   * be set when using the currency field as they are set in this 
   * component above
   */
  symbol: _propTypes2.default.string,
  decimal: _propTypes2.default.string,
  thousands: _propTypes2.default.string,
  negative: _propTypes2.default.string,
  maxDecimalUnits: _propTypes2.default.number,
  formatToCurrency: _propTypes2.default.func
});

CurrencyField.defaultProps = {
  selectAllOnFocus: true
};

exports.default = (0, _reactIntl.injectIntl)(CurrencyField);


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/managewidgets/components/numberfield/CurrencyField.js
// module id = 784
// module chunks = 10